import React from 'react';
import { RadioGroupProps } from 'antd';
import * as S from './styles';

interface CustomRadioProps extends RadioGroupProps {}

export default function InputRadio(props: Readonly<CustomRadioProps>): JSX.Element {
	return <S.RadioGroupWrapper {...props} />;
}
